import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import crudApi from "@serie3/common/api/crudApi";
import SocialEndpoints from "@serie3/mymediaplanner/Modules/Social/endpoints";
import MediaplannerGroupEndpoints from "@serie3/mymediaplanner/Modules/Groups/endpoints";
import DocumentsEndpoints from "@serie3/mymediaplanner/Modules/Documents/endpoints";
import ApprovalScheduleList from "./ApprovalScheduleList";

/**
 * Posts planned on my account that still wait for my decision, across all
 * groups, with the same post modal as a group's Approvals tab. Decided rows
 * drop off the list.
 */
const ApprovalsInbox = () => {
  const { t } = useTranslation();
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    crudApi
      .justGet(SocialEndpoints.posts.schedule.approvals.inbox)
      .then((r) => { if (r.ok) setSchedules(r.data?.schedules ?? []); })
      .finally(() => setLoading(false));
  }, []);

  const pending = schedules.filter((s) => s.approval_status === "proposed");

  const onDecided = (updated) => {
    setSchedules((prev) => prev.map((s) => (s.id === updated.id ? { ...s, ...updated } : s)));
  };

  // Files through the group routes when the post's group is known, else the
  // owner route the publishing user may call.
  const loadFiles = async (schedule) => {
    if (!schedule?.post?.id) return null;
    const groupId = Array.isArray(schedule.post.shared_in) && schedule.post.shared_in[0]?.id ? schedule.post.shared_in[0].id : null;
    const r = await crudApi.getAll(
      groupId
        ? MediaplannerGroupEndpoints.endpoints.postFiles + groupId + "/" + schedule.post.id
        : DocumentsEndpoints.showPostFiles + schedule.post.id
    );
    return {
      files: r?.ok && Array.isArray(r.data) ? r.data : [],
      binaryEndpoint: groupId ? MediaplannerGroupEndpoints.endpoints.getImageBinary + groupId + "/" : undefined,
    };
  };

  return (
    <>
      <h4 className="page-section-header">
        <span className="page-section-header-icon" style={{ background: "rgba(15,123,134,0.12)" }}>
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#0f7b86" }} />
        </span>
        {t("Backend.Approvals.Title", "Approvals")}
        {pending.length > 0 && <span style={{ color: "#8a5a00", marginLeft: 10, fontSize: 14 }}>({pending.length})</span>}
      </h4>

      <Card>
        <Card.Body>
          {loading ? (
            <div className="skeleton" style={{ height: 80, borderRadius: 10 }} />
          ) : (
            <ApprovalScheduleList
              schedules={pending}
              onDecided={onDecided}
              loadFiles={loadFiles}
              showGroup
              showTitle={false}
              showFilter={false}
              emptyText={t("Backend.Approvals.NothingPending", "Nothing waits for your approval.")}
            />
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default ApprovalsInbox;
